// Port of api/fuel/app/classes/model/log/user/tag/attach.php
import Model from 'offline/stream/model/base'
import Constants from 'offline/constants'

export default Model.extend({
	table: 'log_user_tag_attach',
	prefix: 'log',
	key: 'log_id',
	fields: {
		log_id: Model.SCHEMA_KEY,
		log_date: Model.SCHEMA_DATE_CREATE,
		user_id: Model.SCHEMA_NUMBER,
		tag_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		collection_id: Model.SCHEMA_NUMBER,
		rating_id: Model.SCHEMA_NUMBER,
		play_id: Model.SCHEMA_NUMBER,
		log_context: Model.SCHEMA_NUMBER,
		log_initial_sync: Model.SCHEMA_NUMBER,
		log_tag_context: Model.SCHEMA_NUMBER,
		log_tag_text: Model.SCHEMA_TEXT,
		log_tag_colour: Model.SCHEMA_TEXT
	},
	methods: {
		get_type: function() { return Constants.LOG_TYPE_USER_TAG_ATTACH },
		to_array: function() {
			return {
				id: +this.get_id(),
				date: +this.get_date(),
				type: +this.get_type(),
				context: +this.get_context(),
				user: +this.get_user_id(),
				game: +this.get_game_id(),
				collection: +this.get_collection_id(),
				rating: +this.get_rating_id(),
				play: +this.get_play_id(),
				tag: +this.get_tag_id(),
				text: this.get_tag_text(),
				colour: this.get_tag_colour(),
				tagContext: +this.get_tag_context()
			}
		}
	}
})
